/* -----------------UI--------------- */
import { Appbar } from "react-native-paper";
import Box from "../Box";
import TooltipWrapper from "../TooltipWrapper";
import { AppBarMenu } from "./AppBarMenu";

/* -----------------Helpers & Hooks--------------- */
import { defaultAiAssistantInfo } from "@memorang/helpers/constants";
import Icon from "@react-native-vector-icons/material-design-icons/static";

import { memo } from "react";
import useModalHeaderHeight from "../../hooks/useModalHeaderHeight";
import type { IconType } from "../../icon";
/* -----------------Types--------------- */
import type { ChatAppbarProps } from "./types/props";

const BackButton = memo(
	({
		backAction,
	}: { backAction: NonNullable<ChatAppbarProps["backAction"]> }) => {
		return (
			<Appbar.Action
				icon={backAction.icon}
				onPress={backAction.handleAction}
				size={backAction.size}
			/>
		);
	},
);

const ChatAppbar = (props: ChatAppbarProps) => {
	const {
		actions = [],
		menuActions = [],
		title = defaultAiAssistantInfo.title,
		isBackButtonVisible = true,
		backAction,
	} = props;
	const statusBarHeight = useModalHeaderHeight();

	return (
		<Appbar.Header
			elevated
			mode="center-aligned"
			statusBarHeight={statusBarHeight}
		>
			{isBackButtonVisible && <BackButton backAction={backAction} />}
			<Box gap={2} flex={1}>
				<TooltipWrapper title={title}>
					<Appbar.Content
						title={title}
						titleStyle={{
							fontSize: 18,
						}}
						style={{
							flex: 0,
						}}
					/>
				</TooltipWrapper>
			</Box>
			{actions.map(({ icon, handleAction, title, disabled }) => (
				<TooltipWrapper title={title} key={icon}>
					<Appbar.Action
						icon={(props) => <Icon {...props} name={icon as IconType} />}
						onPress={handleAction}
						disabled={disabled}
					/>
				</TooltipWrapper>
			))}
			{menuActions.length > 0 && <AppBarMenu menuActions={menuActions} />}
		</Appbar.Header>
	);
};

export default ChatAppbar;
